import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const PowerSplitCalculatorGuidePage = () => <DataDrivenGuidePage slug="guide-power-split-calculator" />;

export default PowerSplitCalculatorGuidePage;
